export default __webpack_public_path__ + "static/media/blaspheme.c863856e.png";